<div class="shortcuts-card-container" ngbDropdown #helpDrop="ngbDropdown">
  <div class="shortcuts-card" id="shortcutsCard" ngbDropdownToggle>
    <!--<a href="javascript:void(0)">
      <span class="clickimage fa-regular fa-arrow-up-right-from-square"></span>
    </a>-->
  </div>
  <div ngbDropdownMenu aria-labelledby="shortcutsCard">
    <div class="dd-menu-header">Shortcuts</div>
    <div class="dd-menu-separator"></div>
    <button class="dd-menu-item" ngbDropdownItem>Shortcuts will appear here!</button>
    
  </div>
</div>
